/* This component is copied from ImageFeild to add delete button
 * https://github.com/marmelab/react-admin/blob/master/packages/ra-ui-materialui/src/field/ImageField.tsx
*/
import * as React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import classnames from 'classnames';
/*import sanitizeFieldRestProps from 'ra-ui-materialui/esm/field/sanitizeRestProps';*/

const useStyles = makeStyles({
    list: {
        display: 'inline-block',
        justifyContent: 'center',
        listStyleType: 'none',
        paddingLeft: 0,
    },
    image: {
        width: 520,
        /*width: 325,*/
        /*height: 208,*/
    },
    centreItem:{
        display: 'flex',
        alignItems: 'center', 
        marginBottom: 16
    },
});

const PreviewImageField = props => {
    const {
        className,
        classes: classesOverride,
        emptyText,
        record,
        source,
        src,
        title,
        onClick,
        ...rest
    } = props;

    const sourceValue = get(record, source);
    const classes = useStyles(props);

    const handleClick = (e, val) =>{
        onClick(e, val);
    }

    if (!sourceValue) {
        return emptyText ? (
            <Typography
                component="span"
                variant="body2"
                className={className}
                {...rest/*...sanitizeFieldRestProps(rest)*/}
            >
                {emptyText}
            </Typography>
        ) : (
            <div className={className} {...rest/*...sanitizeFieldRestProps(rest)*/} />
        );
    }
    
    if (Array.isArray(sourceValue)) {
        return (
            <ul
                className={classnames(classes.list, className)}
                {...rest/*...sanitizeFieldRestProps(rest)*/}
            >
                {sourceValue.map((file, index) => {
                    const fileTitleValue = get(file, title) || title;
                    const srcValue = get(file, src) || file[src] || title;
                    const fileInfo = get(file, 'file') || null;

                    return (
                        <li key={index} className={classes.centreItem}/*style={{display: 'flex', alignItems: 'center', marginBottom: 16}}*/>
                            <img
                                alt={fileTitleValue}
                                title={fileTitleValue}
                                src={srcValue}
                                className={classes.image}
                            />
                            <IconButton
                                aria-label="delete"
                                color="primary"
                                onClick={e=>handleClick(e, fileInfo)}
                            >
                                <DeleteForeverIcon style={{fill: "#f44336"}}/>
                            </IconButton>
                        </li>
                    );
                })}
            </ul>
        );
    }

    const fileTitleValue = get(record, title) || title;
    const fileInfo = get(record, 'file') || null;
  
    return (
        <div className={classes.centreItem} {...rest/*...sanitizeFieldRestProps(rest)*/}>
            <img
                title={fileTitleValue}
                alt={fileTitleValue}
                src={sourceValue}
                className={classes.image}
            />
            <IconButton 
                aria-label="delete"
                color="primary"
                onClick={e=>handleClick(e, fileInfo)}
            >
                <DeleteForeverIcon style={{fill: "#f44336"}}/>
            </IconButton>
        </div>
    );
};


export default PreviewImageField;
